//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import { dayjsLocalizer } from 'react-big-calendar';
import dayjs from 'dayjs';
import { StyledCalendar } from '../../../thirdParty/calendar/calandar.style';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { AddAttendance } from '@projectK/modules/Attendance';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import AppLoader from '@projectK/components/AppLoader';
import PropTypes from 'prop-types';
import {isCoach,isSuperAdmin,useRolePermissions,hasPermission,isAdmin } from '@projectK/context/RolesProvider';

const localizer = dayjsLocalizer(dayjs);

const AdminCalendar = ({
  csvLoading,
  loading,
  events,
  onMonthChange,
  currentDate,
}) => {
  const { user } = useAuthUser();
  const isFetch = false;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [signUpUsers, setSignUpUsers] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState('all');
  const { rolePermissions } = useRolePermissions();
  const openModal = () => {
    setSelectedEvent(selectedEvent);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent(selectedEvent);
    setIsModalOpen(false);
  };

  const mainDomain = window.location.hostname;
  const formatDate = (date) => {
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    return date
      ? new Intl.DateTimeFormat('en-US', options).format(date)
      : 'N/A';
  };
const handleNavigate = (newDate) => {
  if (!newDate) return;

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const newYear = newDate.getFullYear();
  const newMonth = newDate.getMonth();

  // Calculate total month difference
  const monthDifference =
    (newYear - currentYear) * 12 + (newMonth - currentMonth);
  onMonthChange(monthDifference);
};
  const mapEventData = (event) => {
    let formattedStartDate = new Date(
      `${event?.start_date.substring(0, 10)}T12:01:00`,
    );
    let formattedEndDate = new Date(
      `${event?.end_date.substring(0, 10)}T12:01:00`,
    );
    const parseTime = (timeString) => {
      const [hours, minutes, seconds] = timeString.split(':');
      return new Date(1970, 0, 1, hours, minutes, seconds);
    };

    const localStartTime = event.start_time
    ? parseTime(event.start_time)
    : new Date(1970, 0, 1);
  const localEndTime = event.end_time
    ? parseTime(event.end_time)
    : new Date(1970, 0, 1);
    return {
      title: (
        <div className='sunilb'>
          <strong>
            {event.activity_display_name
              ? event.activity_display_name
              : event.activity_name || 'Untitled Event'}
          </strong>
          <br />
          {localStartTime && (
            <span
              style={{ fontSize: '10px' }}
            >{`${localStartTime.toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              hour12: true,
            })}`}</span>
          )}
          -
          {event.resource_name && (
            <span style={{ fontSize: '10px' }}>
              {` ${
                event.resource_name?.length > 10
                  ? event.resource_name.substring(0, 10)
                  : event.resource_name
              }`}
            </span>
          )}{' '}
          <span style={{ fontSize: '10px' }}>
            {event?.user_session_count ? event.user_session_count : 0} of{' '}
            {event?.max_attendees ? event?.max_attendees : 0}
          </span>
        </div>
      ),

      start: new Date(
        formattedStartDate.getFullYear(),
        formattedStartDate.getMonth(),
        formattedStartDate.getDate(),
        localStartTime.getHours(),
        localStartTime.getMinutes(),
        localStartTime.getSeconds(),
      ),
      end: new Date(
        formattedEndDate.getFullYear(),
        formattedEndDate.getMonth(),
        formattedEndDate.getDate(),
        localEndTime.getHours(),
        localEndTime.getMinutes(),
        localEndTime.getSeconds(),
      ),
      desc: event.description || 'No description available',
      location_name: event.location_name,
      address: event.address,
      resource_name: event.resource_name,
      street: event.street,
      city: event.city,
      state: event.state,
      zip: event.zip,
      instructor_names: event.instructor_names,
      productId: event.product_id,
      activity_name: event.activity_name,
      activity_display_name: event?.activity_display_name,
      instructorId: event.instructor_ids,
      product_theme: event.product_theme,
      user_session_count: event.user_session_count,
      max_attendees: event.max_attendees,
      localStartTime: localStartTime.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
      }),
      localEndTime: localEndTime.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
      }),
      product_slug: event.productSlug,
      sessionId: event.id,
      activityId: event.activity_id,
      reportId: event.report_id,
    };
  };

  const formattedEvents = events.map(mapEventData);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  const handleClose = () => {
    setSelectedEvent(null);
  };
  const productThemes = {
    Green: '#28e100',
    Red: '#cb0022',
    Black: '#060808',
    Orange: '#d95200',
    'Dark Gray': '#262f30',
    'Light Gray': '#b5ccd9',
    Blue: '#02217a',
  };

  useEffect(() => {
    if (selectedEvent?.sessionId) {
      fetchSignUpUsers();
      fetchAttendanceData();
      fetchData();
    }
  }, [selectedEvent?.sessionId]);

  const fetchSignUpUsers = async () => {
    try {
      const response = await jwtAxios.get(
        `/user-session/session-signup/users/${selectedEvent?.sessionId}`,
        {
          params: {
            perPage,
          },
        },
      );
      const { data } = response;
      setSignUpUsers(data?.list);
    } catch (error) {
      setSignUpUsers([]);
    }
  };

  const [attendanceData, setAttendanceData] = useState([]);

  const fetchAttendanceData = async () => {
    try {
      const response = await jwtAxios.get(
        `/attendance/session/${selectedEvent?.sessionId}`,
        {
          params: {
            page,
            perPage,
          },
        },
      );
      const { data } = response;
      setAttendanceData(data?.list);
      data?.list?.length === 0 && page > 0 && setPage(page - 1);
    } catch (error) {
      console.error('An error occurred:', error?.response?.data?.error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await jwtAxios.get(
        `/activity-session/${selectedEvent?.sessionId}`,
      );
      const { data } = response;
      setActivityData(data);
    } catch (error) {
      console.error('An error occurred:', error?.response?.data?.error);
    }
  };

  const canEditSession = hasPermission(
  rolePermissions,
  'Manage Activities - Search Sessions',
  'update'
);

  return (
    <AppScrollbar>
      <div
        className='app-calendar app-cul-calendar'
        style={{ backgroundColor: '#f4f6fe', padding: '10px' }}
      >
        <StyledCalendar
          selectable
          onNavigate={handleNavigate}
          events={formattedEvents}
          localizer={localizer}
          defaultView='month'
          views={['month', 'day', 'agenda']}
          scrollToTime={new Date(1970, 1, 1, 6)}
          defaultDate={currentDate || new Date()}
          onSelectEvent={handleEventClick}
          showMultiDayTimes={true}
          tooltipAccessor={(selectedEventData) =>
            `Title: ${
              selectedEventData.title.props.children[0].props.children
            }\nStart: ${formatDate(
              selectedEventData?.start,
            )}\nEnd: ${formatDate(selectedEventData?.end)}\nResource: ${
              selectedEventData.resource_name
            }`
          }
          eventPropGetter={(formattedEventsData) => {
            const backgroundColor =
              productThemes[formattedEventsData?.product_theme] || '#2196f3';

            return { style: { backgroundColor, color: 'white' } };
          }}
          popup
        />

        {loading || csvLoading ? (
          <AppLoader />
        ) : (
          <Dialog
            className='cal-popup'
            open={Boolean(selectedEvent)}
            onClose={handleClose}
            maxWidth='sm'
          >
            <div className='flex-head'>
              <DialogTitle
                variant='h3'
                className='textwrap'
                sx={{
                  flexGrow: 1,
                  textAlign: 'left',
                  color: '#0A8FDC',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  if (!canEditSession) return;
                  let redirectUrl = '';

                  if (isCoach(user)) {
                    redirectUrl = `http://${mainDomain}/coach/edit-session/${selectedEvent?.product_slug}/${selectedEvent?.sessionId}`;
                  } else if (
                    isSuperAdmin(user) || isAdmin(user)
                  ) {
                    redirectUrl = `http://${mainDomain}/admin/edit-session/${selectedEvent?.product_slug}/${selectedEvent?.sessionId}`;
                  }

                  // Redirect to the constructed URL
                  if (redirectUrl) {
                    window.location.href = redirectUrl;
                  }
                }}
              >
             <Tooltip
              title={
                canEditSession
                  ? `Click here to edit ${
                      selectedEvent?.activity_display_name//NOSONAR
                        ? selectedEvent?.activity_display_name
                        : selectedEvent?.activity_name
                    } session`
                  : ''
              }
            >
              {selectedEvent?.activity_display_name
                ? selectedEvent?.activity_display_name
                : selectedEvent?.activity_name}
            </Tooltip>
              </DialogTitle>
          {hasPermission(rolePermissions, 'Manage Activities - Search Sessions', 'create') && (
              <Button
                variant='outlined'
                size='small'
                sx={{
                  width: 'max-content',
                  height: '25px',
                  borderColor: '#2196f3',
                  color: 'primary',
                  minWidth: '85px',
                }}
                onClick={() => {
                  let redirectUrl = '';

                  if (isCoach(user)) {
                    redirectUrl = `http://${mainDomain}/coach/edit-session/${selectedEvent?.product_slug}/${selectedEvent?.sessionId}`;
                  } else if (
                    isSuperAdmin(user) || isAdmin(user)
                  ) {
                    redirectUrl = `http://${mainDomain}/admin/edit-session/${selectedEvent?.product_slug}/${selectedEvent?.sessionId}`;
                  }
                  // Redirect to the constructed URL
                  if (redirectUrl) {
                    window.location.href = redirectUrl;
                  }
                }}
              >
                <Tooltip
                  title={`click here to edit ${
                    selectedEvent?.activity_display_name
                      ? selectedEvent?.activity_display_name
                      : selectedEvent?.activity_name
                  } session`}
                >
                  session page
                </Tooltip>
              </Button>
          )}
          {hasPermission(rolePermissions, 'Member Information - Attendance Report', 'create') && (
              <Button
                variant='outlined'
                size='small'
                sx={{
                  width: 'max-content',
                  height: '25px',
                  borderColor: '#2196f3',
                  color: 'primary',
                  minWidth: '100px',
                  marginLeft: 2,
                }}
                onClick={openModal}
              >
                Add Attendance
              </Button>
              )}
            </div>

            <Divider sx={{ my: 3 }} />
            <DialogContent>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Attendees
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7}}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>
                        {selectedEvent?.user_session_count} of {''}
                        {selectedEvent?.max_attendees}
                      </span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Instructor
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{selectedEvent?.instructor_names}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Start Time
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{formatDate(selectedEvent?.start)}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      End Time
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{formatDate(selectedEvent?.end)}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Location
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1}}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{selectedEvent?.location_name}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              {/* Add other event details here */}
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Address
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{selectedEvent?.address}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
              <Grid size={{ xs: 4 }} sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='left'>
                      Resource
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 1 }}  sx={{ my: 1 }}>
                  <Typography variant='h4'>
                    <Box display='flex' justifyContent='center'>
                      <span>:</span>
                    </Box>
                  </Typography>
                </Grid>
                <Grid size={{ xs: 7 }}  sx={{ my: 1 }}>
                  <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                    <Box display='flex' justifyContent='flex-start'>
                      <span>{selectedEvent?.resource_name}</span>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>

              {/* Add more details as needed */}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}

        {isModalOpen && (
          <AddAttendance
            isOpen={isModalOpen}
            onClose={closeModal}
            activityId={selectedEvent?.activityId}
            sessionId={selectedEvent?.sessionId}
            activityData={activityData}
            activityLocation={selectedEvent?.location_name}
            productId={selectedEvent?.productId}
            reportId={selectedEvent?.reportId}
            fetchAttendanceData={fetchAttendanceData}
            fetchData={fetchData}
            attendanceData={attendanceData}
            signUpUsers={signUpUsers}
            fetchSignUpUsers={fetchSignUpUsers}
            isFetch={isFetch}
            setPerPage={setPerPage}
          />
        )}
      </div>
    </AppScrollbar>
  );
};

export default AdminCalendar;
AdminCalendar.propTypes = {
  csvLoading: PropTypes.bool,
  loading: PropTypes.bool,
  events: PropTypes.array,
  onMonthChange: PropTypes.func,
  currentDate: PropTypes.instanceOf(Date),
};
